export const SHOW_MODAL_PAYMENTS = "SHOW_MODAL_PAYMENTS";
export const HIDE_MODAL_PAYMENTS = "HIDE_MODAL_PAYMENTS";
export const OPEN_MODAL_TUTORIAL = "OPEN_MODAL_TUTORIAL";
export const CLOSE_MODAL_TUTORIAL = "CLOSE_MODAL_TUTORIAL";

const openModalPaymentsDispatch = (data) => {
    return {
        type: SHOW_MODAL_PAYMENTS, 
        data:data
    };
}

const closeModalPaymentsDispatch = (data) => {
    return {
        type: HIDE_MODAL_PAYMENTS, 
        data:data
    };
}

const openModalTutorialDispatch = (data) => {
    return {
        type: OPEN_MODAL_TUTORIAL, 
        data:data
    };
}

const closeModalTutorialDispatch = (data) => {
    return {
        type: CLOSE_MODAL_TUTORIAL, 
        data:data
    };
}


export const openModalPayments = (open, membershipRole, typePayment, cost) => (dispatch) => {
   process_open_modal_payments(dispatch, open, membershipRole, typePayment, cost)
}

export const closeModalPayments = (open, membershipRole, typePayment, cost) => (dispatch) => {
    process_close_modal_payments(dispatch, open, membershipRole, typePayment, cost)
}

export const openModalTutorial = (open, numerTutorial) => (dispatch) => {
    process_open_modal_tutorial(dispatch, open, numerTutorial)
}

export const closeModalTutorial = (open, numerTutorial) => (dispatch) => {
    process_close_modal_tutorial(dispatch, open, numerTutorial)
}


function process_open_modal_payments (dispatch, open, membershipRole, typePayment, cost){
    dispatch(openModalPaymentsDispatch({open, membershipRole, typePayment, cost}));
}

function process_close_modal_payments (dispatch, open, membershipRole, typePayment, cost){
    dispatch(closeModalPaymentsDispatch({open, membershipRole, typePayment, cost}));
}

function process_open_modal_tutorial (dispatch, open, numerTutorial){
    dispatch(openModalTutorialDispatch({open, numerTutorial}));
}
function process_close_modal_tutorial (dispatch, open, numerTutorial){
    dispatch(closeModalTutorialDispatch({open, numerTutorial}));
}
